import { NgModule } from '@angular/core';
import { PayrollTimesheetComponent } from './payroll-timesheet.component';
import { RouterModule } from '@angular/router';
import { AgGridModule} from 'ag-grid-angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { AuthGuardService } from '../services/auth-guard.service';
import { TooltipModule } from 'primeng/tooltip';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    AgGridModule.withComponents([]),

    BadgeModule,
    BreadcrumbModule,
    ButtonModule,
    CalendarModule,
    DividerModule,
    DropdownModule,
    ToastModule,
    ToolbarModule,
    TooltipModule,
        
    RouterModule.forChild([
      {path: 'payroll-timesheet', component: PayrollTimesheetComponent, canActivate: [AuthGuardService] }
    ])
  ],
  declarations:[
    PayrollTimesheetComponent
  ]
})
export class PayrollModule{
}